"use client";

import { openPrivacyChoicesEvent } from "@/components/analytics-consent-banner";

type PrivacyChoicesButtonProps = {
  label?: string;
};

export function PrivacyChoicesButton({ label = "Privacy choices" }: PrivacyChoicesButtonProps) {
  return (
    <button className="site-footer__privacy-button" onClick={() => window.dispatchEvent(new Event(openPrivacyChoicesEvent))} type="button">
      {label}
    </button>
  );
}
